export const TableMixins = {
    data() {
        return {
            queryParam: {}, dataSource: [], loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '30', '50'],
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            sorter: {
                column: 'createTime', order: 'desc',
            },
            filters: {},
            selectedRowKeys: [],
            selectionRows: []
        }
    },

    methods: {

        handleTableChange(pagination, filters, sorter) {
            if (Object.keys(sorter).length > 0) {
                this.sorter.column = sorter.field;
                this.sorter.order = "ascend" === sorter.order ? "asc" : "desc"
            }
            this.pagination = pagination;
            this.filters = filters;
            this.loadData();
        },

        onSelectChange(selectedRowKeys, selectionRows) {
            this.selectedRowKeys = selectedRowKeys;
            this.selectionRows = selectionRows;
        },

        getQueryParams() {
            let param = Object.assign({}, this.queryParam, this.sorter, this.filters);
            //将某些字段的数组转换为字符串
            for (let key in param) {
                if (Array.isArray(param[key])) {
                    param[key] = param[key].join(",");
                }
            }
            param.pageNo = this.pagination.current;
            param.pageSize = this.pagination.pageSize;
            return param;
        },


        loadData: function (arg) {
            let that = this;
            if (arg === 1) {
                this.pagination.current = 1;
            }
            that.loading = true;
            let params = that.getQueryParams();

            const handleSuccess = (res) => {
                if (res) {
                    const response = res.data;
                    that.dataSource = response.records;
                    that.pagination.total = response.total;
                    that.selectedRowKeys = [];
                }
                that.loading = false;
            };

            this.$axios.get(that.url.list, {params, headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
        }


    },

}
